import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import React from 'react';
import {useSelector} from 'react-redux';
import {getHTMLRepresentation} from 'model/Person';
import {selPersonSelected, selPersonTemplateId} from 'module/Person/selector/PersonSelector'
import {css} from '@emotion/react'
import Tooltip from '@mui/material/Tooltip'

const cssLabelText = css`
	max-height: 24px;
`
export const PersonPanelButton = React.memo((props: TopNavBarButtonProps) => {
	const {btnDef} = props
	const selected = useSelector(selPersonSelected)
	const templateId = useSelector(selPersonTemplateId)
	return (
		<Tooltip title={selected && <div dangerouslySetInnerHTML={{__html: getHTMLRepresentation(selected, templateId)}}/>}>
			<div>
				<TopNavBarButtonComponent{...props}>
					<SupervisorAccountIcon fontSize={'small'}/>&nbsp;
					{btnDef?.label && selected &&
						<span
							css={cssLabelText}
							dangerouslySetInnerHTML={{__html: getHTMLRepresentation(selected, templateId)}}
						/>
						|| btnDef?.label &&
						<span css={cssLabelText}>Personen</span>
					}
				</TopNavBarButtonComponent>
			</div>
		</Tooltip>
	);
});